export default __webpack_public_path__ + "static/media/logo192.a3e4319f.png";